export default __webpack_public_path__ + "static/media/fr.dd9dc78a.jpg";